import { Directive, inject, Input, Renderer2, TemplateRef, ViewContainerRef } from '@angular/core';

import { EmailMailgunIfComponent } from './email-mailgun-if.component';
import type { WrappedValue } from '../mailgun/wrap-value';
import { TemplateRendererConfig } from '../providers/template-renderer-config';

@Directive({
  selector: '[mailgunIf]',
  standalone: true,
})
export class EmailMailgunIfDirective {
  public config = inject(TemplateRendererConfig);
  public renderer = inject(Renderer2);
  public vcRef = inject(ViewContainerRef);
  public oKTemplate = inject(TemplateRef<any>);

  @Input('mailgunIfElse') public elseTemplate?: TemplateRef<unknown>;
  @Input('mailgunIf') public variable: WrappedValue<any>;

  private component = this.vcRef.createComponent(EmailMailgunIfComponent);

  public ngOnChanges() {
    this.displayTemplate();
  }

  private displayTemplate() {
    this.vcRef.clear();

    if (this.config.interpolate) {
      this.applyInterpolateMode();
    } else {
      this.applyMailgunMode();
    }
  }

  private applyInterpolateMode() {
    this.vcRef.createEmbeddedView(this.component.instance.interpolateIf, this.getContext());
  }

  private applyMailgunMode() {
    this.vcRef.createEmbeddedView(this.component.instance.mailgunIf, this.getContext());
  }

  private getContext() {
    return {
      prop: this.variable,
      ok: this.oKTemplate,
      notOk: this.elseTemplate,
    };
  }
}
